<template>
  <main>
    <div v-if="currentUser !== null" class="inbox">
      <headerFeed :currentUser="currentUser" title="Feedback a Fluxers"></headerFeed>

      <md-layout md-gutter class="contenidoPagina">
        <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
          <main>
            <h3 class="md-title"> Pendientes </h3>
            <md-spinner v-show="loader" md-indeterminate></md-spinner>
            <p v-if="feedPendientes.length === 0 && !loader">No tienes Feedbacks pendientes aun</p>
            <div v-for="feed in feedPendientes" :key="feed.key">
              <feedback @click.native="openDetail(feed)" :feedback="feed" :fluxer="feed.owner" :texto="getTitle(feed)"></feedback>
              <br>
            </div>
          </main>
        </md-layout>

        <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
          <main>
            <h3 class="md-title"> Enviados </h3>
            <md-spinner v-show="loader" md-indeterminate></md-spinner>
            <p v-if="feedFinalizados.length === 0 && !loader">No tienes Feedbacks finalizados aun</p>
            <div v-for="feed in feedFinalizados" :key="feed.key">
              <feedback @click.native="openDetail(feed)"  :feedback="feed" :fluxer="feed.owner" :texto="getTitle(feed)"></feedback>
              <br>
            </div>
          </main>
        </md-layout>
      </md-layout>
    </div>
    <div v-if="currentUser == null">
      el currentUser es null!!
    </div>

    <md-button @click.native="openSelectFluxer('selectFluxer')" class="md-icon-button espontaneo md-raised md-primary">
      <md-icon>add</md-icon>
      <md-tooltip md-direction="left">Dar feedback espontaneo</md-tooltip>
    </md-button>

    <feedback-companion ref="selectFluxer" :isEspontaneo="true" :currentFluxer="currentFluxer[0]"></feedback-companion>

    <router-view></router-view>

  </main>
</template>

<script>

import header from './Header'
import feedback from './Feedback'
import Router from '../router'
import FluxerService from '../services/fluxer'
import FeedbacksService from '../services/feedbacks'
import feedbackCompanion from './FeedbackCompanion'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'inbox',
  components: {
    'headerFeed': header,
    'feedback': feedback,
    'feedback-companion': feedbackCompanion
  },
  data () {
    return {
      loader: true,
      currentUser: FluxerService.getCurrentUser()
    }
  },
  created () {
    window.OneSignal.push(function () {
      window.OneSignal.registerForPushNotifications()
    })
  },
  computed: {
    feedPendientes: function () {
      let fechaCorte = moment('2019-11-7')
      return _.filter(this.misFeedbacks, function (f) {
        // mostrar los pendientes propios nomas
        return moment(f.created).isAfter(fechaCorte) && !f.completed
      })
    },
    feedFinalizados: function () {
      return _.filter(this.misFeedbacks, function (f) { return f.completed })
    }
  },
  firebase: function () {
    this.loader = true
    return {
      misFeedbacks: {
        source: FeedbacksService.getFeedbacksByEditor(this.currentUser.email),
        readyCallback: function () {
          this.loader = false
        }
      },
      currentFluxer: FluxerService.getFluxerByEmail(this.currentUser.email)
    }
  },
  methods: {
    openDetail (feedback) {
      if (feedback.editor === this.currentUser.email || feedback.completed) {
        Router.push({name: 'feedback-detail', params: {id: feedback['.key'], feedback: feedback, currentUser: this.currentUser}})
      }
    },
    openSelectFluxer (ref) {
      this.$refs[ref].open()
    },
    getTitle (feedback) {
      if (feedback.tipo === 'lider') {
        return 'Líder'
      } else if (feedback.tipo === 'autoeval') {
        return 'Reflexión Personal'
      } else if (feedback.tipo === 'companion') {
        return 'Fluxer'
      } else {
        return 'Espontáneo'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .espontaneo  {
    position: fixed !important;
    right: 10px;
    bottom: 10px;
    width: 56px !important;
    height: 56px !important;
    z-index: 10;
  }

  .contenidoPagina {
    padding-top: 64px;
  }
</style>



// WEBPACK FOOTER //
// Inbox.vue?dc4b75c8